export default "/fonts/vendor/@fontsource/lato/files/lato-latin-700-normal.woff2?8f28e0e1fdb195149f1c30f84d951b61";